module.exports = __webpack_public_path__ + "static/media/feature-tile-icon-06.6a177696.svg";